import { atom } from 'recoil';

const { innerWidth: width, innerHeight: height } = window;
export const viewState = atom({
  key: 'viewState',
  default: { height, width },
})